import React from 'react';
import { Col, Container, Row } from "reactstrap";
import title from '../assets/img/index/title.png'
import logo1 from '../assets/img/index/logo1.png'
import logo2 from '../assets/img/index/logo2.png'
import logo3 from '../assets/img/index/logo3.png'
import './css/index.css'
import Colleaguebutton from "./component/ColleagueButton";
import TopLink from './component/TopLink';
import AppButton from './component/AppButton';
import image1 from '../assets/img/index/amar.png'
import image2 from '../assets/img/index/pezeski-ghanooni.png'
import image3 from '../assets/img/index/fata.png'
import image4 from '../assets/img/index/mokhder.png'
import image5 from '../assets/img/index/pishgiri.jpg'
import image6 from '../assets/img/index/refah.png'
import image7 from '../assets/img/index/sabt.png'
import image8 from '../assets/img/index/sazman.png'

const Index = (props) => {
    const buttons = [
        { link: '/', name: 'خانه', color: '#289bd6' },
        { link: '/faq', name: 'قوانین و مقررات', color: '#1794d2' },
        { link: '/', name: 'میز خدمت', color: '#0083c7' },
        { link: '/admin/dashboard', name: 'داشبورد مدیریتی رصد آسیب های اجتماعی', color: '#007fc1' },
        { link: '/', name: 'سازمان های همکار', color: '#0071b0' },
    ]
    const Cbuttons = [
        { link: 'https://lmo.ir/', name: 'پزشکی قانونی', image: image2 },
        { link: 'https://www.sabteahval.ir/', name: 'ثبت احوال', image: image7 },
        { link: 'http://news.dchq.ir/3/', name: 'ستاد مبارزه با مواد مخدر', image: image4 },
        { link: 'https://nsoc.ir/', name: 'سازمان امور اجتماعی کشور', image: image8 },
        { link: 'https://www.cyberpolice.ir/ ', name: 'پلیس فتا', image: image3 },
        { link: 'https://www.amar.org.ir/', name: 'مرکز آمار', image: image1 },
        { link: 'https://scpd.eadl.ir//', name: 'معاونت اجتماعی قوه قضائیه', image: image5 },
        { link: '/https://dsw.mcls.gov.ir/', name: 'معاونت رفاه اجتماعی وزارت تعاون', image: image6 }
    ]

    const Abuttons = [
        { link: 'http://moshaver.behzisti.ir', name: 'سامانه مشاوره مجازی' },
        { link: 'http://123.behzisti.ir', name: 'سامانه 123' },
        { link: 'http://corona.behzisti.net', name: 'سامانه خود ارزیابی بحران کرونا' },
        { link: 'http://zaman.behzisti.net', name: 'سامانه تصمیم' },
    ]

    return (
        <div className="content">
            <div id="top-menu" className="text-center">
                <Row>
                    <Col sm="1"></Col>
                    <Col sm="10">
                        {buttons && buttons.map((b, i) => (
                            <TopLink link={b.link}
                                color={b.color}
                                name={b.name}
                            />
                        ))
                        }</Col>
                    <Col sm="1"></Col>
                </Row>
            </div>
            <div id="background">
                <Row>
                    <Col sm="3"><img className={'logo1'} src={logo1} alt="logo2" /></Col>
                    <Col sm="6"></Col>
                    <Col sm="3" className="text-right"></Col>
                </Row>
            </div>
            <Container fluid className={'indexContent roya'}>
                <Row className={'header'}>
                    <img className={'titleimg'} src={title} alt="title" />
                </Row>
                <Row>
                    <Col md={3}>
                    </Col>
                    <Col md={3}>
                        <div className="logo-holder">
                            <img className={'h-90'} src={logo2} alt="logo2" />
                        </div>
                    </Col>
                    <Col md={3} className={'text-justify roya brief-description'}>
                        <p >
                        سامانه رصد آسیب های اجتماعی و عوامل تعیین کننده آن در راستای اجرای نظام جامع رصد آسیب های اجتماعی مصوب ۱۳۹۸ شورای اجتماعی کشور، موضوع جزء ۴ از بند الف ماده ۸۰ قانون برنامه پنج ساله ششم توسعه کشور مصوب ۱۳۹۵ مجلس شورای اسلامی، با هدف پایش و پیمایش آسیب های اجتماعی و تعیین کننده های آن در سازمان بهزیستی کشور راه اندازی شده است.
                        </p>
                        <p>&nbsp;</p>
                    </Col>
                    <Col md={3} className={'logoes'}>
                    </Col>
                </Row>
                <Row className={"justify-content-center roya"}>
                    <Col sm={6}>
                        <h2 className={'text-center'}>سازمان های همکار</h2>
                        <Row>
                            {Cbuttons && Cbuttons.map((b, i) => (
                                <Col sm={3}>
                                    <Colleaguebutton link={b.link}
                                        name={b.name}
                                        image={b.image}
                                    />
                                </Col>
                            ))

                            }
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                    </Col>
                    <Col sm={8}>
                        <Row>
                            <Col>
                                <p>&nbsp;</p>
                                <h2 className={'text-center font-weight-600'}>سامانه های مرتبط</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-center">
                                {Abuttons && Abuttons.map((b, i) => (
                                    <Col sm={3}>
                                        <AppButton link={b.link}
                                            name={b.name}
                                        />
                                    </Col>
                                ))}
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={2}>
                    </Col>
                    <Col sm={12}>
                        &nbsp;
                    </Col>

                </Row>
                <Row className={'home-footer'}>
                    <Col sm={2}>
                    </Col>
                    <Col sm={4} className="text-right">
                        <i className="botton-icon fa fa-home"></i><span className="address"> تهران، میدان امام خمینی(ره)، خیابان فیاض‌بخش، شماره ۱۱۲۱ <br />سازمان بهزیستی کشور</span>
                    </Col>
                    <Col sm={4} className="text-right">
                        <Row>
                            <Col>
                                <i className="botton-icon fa fa-phone"></i><span className="address"> 66702001 - 021</span>
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <i className="botton-icon fa fa-envelope"></i><span className="address"> info@seraj.ir</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={2}>
                    </Col>
                </Row>
                <Row className={'copyrigth'}>
                    <Col className="text-center">
                        کلیه حقوق مادی و معنوی این سایت متعلق به دبیرخانه ملی رصد آسیب های اجتماعی می باشد
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default Index;